import { ChangeDetectorRef, Component, EventEmitter, Input,
    OnChanges, Output, SimpleChanges, ViewChild, ViewContainerRef } from "@angular/core";
import { AbstractControl, FormArray, FormGroup, UntypedFormBuilder,
    UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { ActionButtonKind, ValidatorsVituCustom, TelephoneRegex,
    DomainNameRegex, VituToastService, VituToastTone, LocalTimePoint, DateTimeLabelUtils } from "shared-lib";
import { ActivatedRoute } from "@angular/router";
import { MerchantTerminalDetailsDto } from "@admin_api/models/merchant-terminal-details-dto";
import { GatewayEnum } from "@admin_api/models/gateway-enum";
import { UpdateMerchantTerminalDto } from "@admin_api/models/update-merchant-terminal-dto";
import { MerchantTerminalConfigDto } from "@admin_api/models/merchant-terminal-config-dto";
import { CloverEcommConfigDto } from "@admin_api/models/clover-ecomm-config-dto";
import { CloverPosConfigDto } from "@admin_api/models/clover-pos-config-dto";
import { RcConfigDto } from "@admin_api/models/rc-config-dto";
import { CreateMerchantTerminalDto } from "@admin_api/models/create-merchant-terminal-dto";
import { PosTerminalStatusEnum } from "@admin_api/models/pos-terminal-status-enum";
import { MerchantProcessorDto } from "@admin_api/models/merchant-processor-dto";
import { OrganizationDto } from "@admin_api/models/organization-dto";
import { MerchantProcessorCloverDeviceDto } from "@admin_api/models/merchant-processor-clover-device-dto";
import { ProcessorEnum } from "@admin_api/models/processor-enum";
import { DigitalWalletConfigRequest } from "@admin_api/models/digital-wallet-config-request";
import { AppleMerchantDomainName } from "@admin_api/models/apple-merchant-domain-name";
import { ApplePayConfigResponse } from "@admin_api/models/apple-pay-config-response";
import { ShowInformationModalAction } from "@admin_app/storage/app/app.actions";
import { Store } from "@ngrx/store";
import { IStore } from "@admin_app/storage/store";
import { PosTerminalModelEnum } from "@admin_api/models/pos-terminal-model-enum";
import { DigitalWalletConfigError } from "@admin_api/models/digital-wallet-config-error";
import { MerchantTerminalConfigBaseDto } from "@admin_api/models/merchant-terminal-config-base-dto";

type FormConfig<T> = { [P in keyof T]: any[] };
type FormControls<T> = { [P in keyof T]: AbstractControl };

enum FormFieldInteraction {
    HIDDEN,
    VIEW,
    EDIT
}

enum TidFormField_COMMON {
    COMMON_MID = "COMMON_MID",
    COMMON_GATEWAY = "COMMON_GATEWAY"
}

enum TidFormField_CLOVER_ECOMM {
    CLOVER_ECOMM_TID = "CLOVER_ECOMM_TID",
    CLOVER_ECOMM_MAI = "CLOVER_ECOMM_MAI",
    CLOVER_ECOMM_TERMS_AND_CONDITIONS_URL = "CLOVER_ECOMM_TERMS_AND_CONDITIONS_URL",
    CLOVER_ECOMM_SERVICE_CONTACT_NUMBER = "CLOVER_ECOMM_SERVICE_CONTACT_NUMBER"
}

enum TidFormField_CLOVER_POS {
    CLOVER_POS_MAI = "CLOVER_POS_MAI",
    CLOVER_POS_DEVICE_SERIAL = "CLOVER_POS_DEVICE_SERIAL",
    CLOVER_POS_DEVICE_MANUFACTURER = "CLOVER_POS_DEVICE_MANUFACTURER",
    CLOVER_POS_DEVICE_MODEL = "CLOVER_POS_DEVICE_MODEL",
    CLOVER_POS_DEVICE_NAME = "CLOVER_POS_DEVICE_NAME",
    CLOVER_POS_DEVICE_LOCATION = "CLOVER_POS_DEVICE_LOCATION",
    CLOVER_POS_STATUS = "CLOVER_POS_STATUS",
    CLOVER_POS_DEVICE_ACTIVATION_CODE = "CLOVER_POS_DEVICE_ACTIVATION_CODE"
}

enum TidFormField_RC {
    RC_TID = "RC_TID",
    RC_MAI = "RC_MAI",
    RC_DATAWIRE_ID = "RC_DATAWIRE_ID",
    RC_REGENERATE_DATAWIRE_ID = "RC_REGENERATE_DATAWIRE_ID",
    RC_TERMS_AND_CONDITIONS_URL = "RC_TERMS_AND_CONDITIONS_URL",
    RC_SERVICE_CONTACT_NUMBER = "RC_SERVICE_CONTACT_NUMBER",
    RC_CLIENT_TIMEOUT_SECONDS = "RC_CLIENT_TIMEOUT_SECONDS",
    RC_GROUP_ID = "RC_GROUP_ID",
    RC_PROJECT = "RC_PROJECT",
    RC_TA_TOKEN_TYPE = "RC_TA_TOKEN_TYPE",
    RC_ENABLE_GOOGLE_PAY = "RC_ENABLE_GOOGLE_PAY",
    RC_GOOGLE_PAY_MERCHANT_ID = "RC_GOOGLE_PAY_MERCHANT_ID",
    RC_ENABLE_APPLE_PAY = "RC_ENABLE_APPLE_PAY",
    RC_APPLE_PAY_MERCHANT_ID = "RC_APPLE_PAY_MERCHANT_ID",
    RC_APPLE_PAY_MERCHANT_NAME = "RC_APPLE_PAY_MERCHANT_NAME",
    RC_APPLE_PAY_MERCHANT_URL = "RC_APPLE_PAY_MERCHANT_URL",
    RC_APPLE_PAY_DOMAIN_NAMES = "RC_APPLE_PAY_DOMAIN_NAMES"
}

enum TidFormField_PayPal {
    PAYPAL_TID = "PAYPAL_TID"
}

@Component({
    selector: "app-tid-details",
    templateUrl: "./tid-details.component.html",
    styleUrls: ["./tid-details.component.less"],
    standalone: false
})
export class TidDetailsComponent implements OnChanges {

    @Input() isCreate: boolean;

    @Input() set merchant(value: OrganizationDto) {
        // Only need to set value once (Allows reassign device modal to open on top & reuse NGRX merchant state)
        if (!this._merchant && value) {
            this._merchant = value;
        }
    }
    get merchant(): OrganizationDto {
        return this._merchant;
    }
    _merchant: OrganizationDto;

    @Input() tid: MerchantTerminalDetailsDto;
    @Input() tidLoading = false;

    @Input() set mids(value: Array<MerchantProcessorDto>) {
        // Only need to set value once (Allows reassign device modal to open on top & reuse NGRX mids state)
        if (!this._mids?.length && value.length) {
            this._mids = value;
            this._mids.forEach((mid: any) => {
                const dbaLabel = mid.dba ?? `—`;
                mid.label = `${mid.mid} (${dbaLabel})`;
            });
        }
//        this.cd.detectChanges();
    }
    get mids(): Array<MerchantProcessorDto> {
        return this._mids;
    }
    _mids: Array<MerchantProcessorDto> = [];

    @Output() reassignDevice = new EventEmitter<any>();
    @Output() pairDevice = new EventEmitter<any>();
    @Output() deleteTid = new EventEmitter<any>();
    @Output() updateTid = new EventEmitter<any>();
    @Output() createTid = new EventEmitter<any>();
    @Output() cancel = new EventEmitter<void>();
    @Output() getGooglePayMerchantId = new EventEmitter<any>();
    @Output() getApplePayMerchantId = new EventEmitter<any>();
    @Output() syncApplePay = new EventEmitter<any>();
    @Output() getDomainValidationFile = new EventEmitter<any>();

    @Input() midCloverDevices: Array<MerchantProcessorCloverDeviceDto>;
    @Input() midCloverDevicesLoading: boolean;
    @Input() midCloverDevicesError: Error;
    @Output() getCloverDevices = new EventEmitter<{organizationId: number; merchantProcessorId: number}>();
    initCloverDevices = false;
    cloverPosTid: string;

    @ViewChild("applePayDomainAdd", {read: ViewContainerRef}) applePayDomainAdd: ViewContainerRef;
    @ViewChild("applePaySync", {read: ViewContainerRef}) applePaySync: ViewContainerRef;

    applePayRegistered: boolean;
    applePayInitialDomainsCount = 0;

    GatewayEnum = GatewayEnum;
    PosTerminalStatusEnum = PosTerminalStatusEnum;

    organizationId: string;

    submitButtonText: string;

    ActionButtonKind = ActionButtonKind;
    FormFieldInteraction = FormFieldInteraction;

    tidForm: UntypedFormGroup;

    showDatawireId: boolean;
    storedDataWireIdInputValue: string;
    storedShowDatawireId: boolean;

    // Future : These 2 arrays should populated from server call when we have more manufacturers & models
    deviceManufacturers = ["Clover"];
    deviceModels: Array<PosTerminalModelEnum>;

    gateways: Array<any>;
    statuses: Array<any>;

    formInitialized = false;
    formInitializedWithGoogleMerchantId = false;
    formInitializedWithAppleMerchantId = false;

    // Only used when dynamically getting the value after the form is initialized
    @Input() dynamicGooglePayMerchantId = null;
    @Input() dynamicApplePayMerchantId = null;
    @Input() dynamicApplePayConfig: ApplePayConfigResponse = null;

    configErrorNoAppleMerchantIdCert: string;

    LocalTimePoint = LocalTimePoint;
    DateTimeLabelUtils = DateTimeLabelUtils;

    get gateway(): GatewayEnum {
        return this.getFieldValue(TidFormField_COMMON.COMMON_GATEWAY);
    }

    get merchantProcessorId(): number {
        const midVal = this.getFieldValue(TidFormField_COMMON.COMMON_MID);
        return this.getMerchantProcessorIdForMid(midVal);
    }

    get merchantProcessorIsServiceFee(): boolean {
        const midVal = this.getFieldValue(TidFormField_COMMON.COMMON_MID);
        return this.getMerchantProcessorIsServiceFeeForMid(midVal);
    }

    get merchantProcessorProcessor(): ProcessorEnum {
        const midVal = this.getFieldValue(TidFormField_COMMON.COMMON_MID);
        return this.getMerchantProcessorProcessorForMid(midVal);
    }

    get cloverMID() {
        let cloverMID = "Not Configured";
        if (this.tid && this._mids?.length) {
            let midValue: string;
            let gateway;
            if (this.isCreate) {
                midValue = this.getFieldValue(TidFormField_COMMON.COMMON_MID);
                gateway = this.getFieldValue(TidFormField_COMMON.COMMON_GATEWAY);
            }
            else {
                midValue = this.tid.mid;
                gateway = this.tid.gateway;
            }
            if (midValue && gateway && gateway != GatewayEnum.RC) {
                const filtered = this._mids.filter(mid => (mid.mid === midValue));
                if (filtered?.length) {
                    const value = filtered[0].gatewayConfig?.clover?.cloverMID;
                    if (value) {
                        cloverMID = value;
                    }
                }
            }
        }

        return cloverMID;
    }

    get deviceNotAssociatedWithCloverMerchant(): boolean {
        let retVal = false;
        const deviceSerial = this.getFieldValue(TidFormField_CLOVER_POS.CLOVER_POS_DEVICE_SERIAL);
        if (deviceSerial && (this.midCloverDevices?.length > 0) &&
            (!this.midCloverDevicesError) && (!this.midCloverDevicesLoading)) {
            const matched = this.midCloverDevices.filter(midCloverDevice => midCloverDevice.serial === deviceSerial);
            if (!matched.length) {
                retVal = true;
            }
        }
        return retVal;
    }

    tidFormFields: Array<string>;

    initialFormConfig: any = {};

    constructor(
        private route: ActivatedRoute,
        private fb: UntypedFormBuilder,
        private toast: VituToastService,
        private store: Store<IStore>,
        private cd: ChangeDetectorRef
    ) {
        this.deviceModels = Object.values(PosTerminalModelEnum);
        this.gateways = Object.values(GatewayEnum);
        this.statuses = Object.values(PosTerminalStatusEnum).sort();

        this.tidFormFields = Object.values(TidFormField_COMMON);
        this.tidFormFields = this.tidFormFields.concat(Object.values(TidFormField_CLOVER_ECOMM));
        this.tidFormFields = this.tidFormFields.concat(Object.values(TidFormField_CLOVER_POS));
        this.tidFormFields = this.tidFormFields.concat(Object.values(TidFormField_RC));
        this.tidFormFields = this.tidFormFields.concat(Object.values(TidFormField_PayPal));

        const tidFormConfig: FormConfig<any> = {};
        this.tidFormFields.forEach(tidFormField => {
            if (tidFormField === TidFormField_RC.RC_APPLE_PAY_DOMAIN_NAMES) {
                tidFormConfig[tidFormField] = this.fb.array(this.initApplePayDomains()) as any;
            }
            else {
                tidFormConfig[tidFormField] = [null, []];
            }
        });
        this.tidForm = this.fb.group(tidFormConfig);
    }

    onClickAddApplePayDomain() {
        this.addToApplePayDomainNames();
        this.markFormDirty();
        this.scrollApplePayIntoView();
    }

    onClickSyncApplePay(formDirty: boolean) {
        this.syncApplePay.emit({
            id: this.tid.id,
            organizationId: this.organizationId,
            formDirty
        });
    }

    onClickGetDomainValidationFile() {
        this.getDomainValidationFile.emit({
            id: this.tid.id,
            organizationId: this.organizationId
        });
    }

    showRemoveApplePayDomainButton(index: number) {
        const domainControl = this.applePayDomainNamesControl?.at(index);
        if (domainControl) {
            const updateShouldDeleteControl = domainControl?.get("updateShouldDelete");
            if (updateShouldDeleteControl?.value) {
                return false;
            }
            const syncShouldDeleteControl = domainControl?.get("shouldBeDeleted");
            if (syncShouldDeleteControl?.value) {
                return false;
            }
        }
        return true;
    }

    onClickRemoveApplePayDomain(index: number) {

        if (this.isApplePayDomainDisabled(index)) {
            const domainControl = this.applePayDomainNamesControl?.at(index);
            if (domainControl) {
                const updateShouldDeleteControl = domainControl?.get("updateShouldDelete");
                if (updateShouldDeleteControl) {
                    updateShouldDeleteControl.setValue(true);
                    updateShouldDeleteControl.updateValueAndValidity();
                    this.markFormDirty();
                }
            }
        }
        else {
            this.applePayDomainNamesControl?.removeAt(index);
            this.markFormDirty();
        }
    }

    private markFormDirty() {
        // Because we're dirtying it manually here (ie. programmatic)
        // not sure why 'this.tidForm.markAsDirty()' doesn't just work here?
        Object.keys(this.tidForm.controls).forEach(field => {
            const control = this.tidForm.get(field);
              control.markAsDirty();
        });
        this.cd.detectChanges();
    }

    get applePayDomainNamesControl() {
        return this.getFormControl(TidFormField_RC.RC_APPLE_PAY_DOMAIN_NAMES) as any;
    }

    isAppleDomainVerifed(domainForm: FormGroup) {
        return !!domainForm.get("verified").value;
    }

    appleDomainShouldBeDeleted(domainForm: FormGroup) {
        if (!!domainForm.get("shouldBeDeleted").value) {
            return "Synchronization Will Try Delete";
        }
        else if (!!domainForm.get("updateShouldDelete").value) {
            return "Update Will Try Delete";
        }
        return "";
    }

    private conditionalValidatorRequired = () => {
        // Workaround => Using FormArray for 'TidFormField_RC.RC_APPLE_PAY_DOMAIN_NAMES'
        // which causes issues when the widgets aren't on screen (ie. there validators
        // shouldn't affect the overall form.  So this custom validation override
        // only applies the validator if the item is on screen.

        const that = this;

        const conditionalValidatorRequiredInner = (c: UntypedFormControl) =>
            that.applePayMerchantIdFieldHasValue ? Validators.required(c) : null;

        return conditionalValidatorRequiredInner;
    };

    private conditionalValidatorPattern = (pattern: RegExp) => {
        // Workaround => Using FormArray for 'TidFormField_RC.RC_APPLE_PAY_DOMAIN_NAMES'
        // which causes issues when the widgets aren't on screen (ie. there validators
        // shouldn't affect the overall form.  So this custom validation override
        // only applies the validator if the item is on screen.

        const that = this;

        const conditionalValidatorPatternInner = (c: UntypedFormControl) => {
            const valid = !that.applePayMerchantIdFieldHasValue || !c.value?.length || pattern.test(c.value);
            return valid ? null : {
                pattern: {
                    valid: false
                }
            };
        };

        return conditionalValidatorPatternInner;
    };

    private initApplePayDomains(applePayDomains?: Array<AppleMerchantDomainName>) {
        let domains;
        if (applePayDomains) {
            domains = applePayDomains.map((applePayDomain, index) => {
                const validators = [/*Validators.required,*/ this.conditionalValidatorPattern(DomainNameRegex)];
                const retVal = this.fb.group({
                    name: [applePayDomain.name, validators],
                    verified: [applePayDomain.verified],
                    shouldBeDeleted: [applePayDomain.shouldBeDeleted],
                    updateShouldDelete: [false]
                });
                return retVal;
            });
        }
        else {
            domains = [
                this.fb.group({
                    name: [null, [this.conditionalValidatorRequired(), this.conditionalValidatorPattern(DomainNameRegex)]],
                    verified: [false],
                    shouldBeDeleted: [false],
                    updateShouldDelete: [false]
                })
            ];
        }
        this.applePayInitialDomainsCount = domains?.length ?? 0;
        return domains;
    }

    private addToApplePayDomainNames() {
        const item = this.fb.group({
            name: [null, [this.conditionalValidatorRequired(), this.conditionalValidatorPattern(DomainNameRegex)]],
            verified: [false],
            shouldBeDeleted: [false],
            updateShouldDelete: [false]
        });
        this.applePayDomainNamesControl.push(item);
    }

    private scrollApplePayIntoView() {
        setTimeout(() => {
            this.applePaySync?.element?.nativeElement?.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 100); // sometimes needs small timeout? (chrome?)
    }

    getFormControl(name: string): UntypedFormControl {
        return this.tidForm.controls[name] as UntypedFormControl;
    }

    get googlePayMerchantIdFieldHasValue() {
        return !!(this.getFieldValue(TidFormField_RC.RC_GOOGLE_PAY_MERCHANT_ID)?.length);
    }

    get applePayMerchantIdFieldHasValue() {
        return !!(this.getFieldValue(TidFormField_RC.RC_APPLE_PAY_MERCHANT_ID)?.length);
    }

    get applePayMerchantUrlFieldIsHidden() {
        const applePayMerchantUrl = this.getFieldValue(TidFormField_RC.RC_APPLE_PAY_MERCHANT_URL);
        const applePayMerchantUrlDisabled = this.isFieldDisabled(TidFormField_RC.RC_APPLE_PAY_MERCHANT_URL);
        const applePayMerchantUrlEmpty = !applePayMerchantUrl?.length;
        return !this.applePayMerchantIdFieldHasValue || (applePayMerchantUrlDisabled && applePayMerchantUrlEmpty);
    }

    private updateApplePayConfig() {
        if (this.dynamicApplePayConfig) {
            this.applePayRegistered = this.dynamicApplePayConfig.registered;
            const applePayDomainNames = this.dynamicApplePayConfig.domainNames;
            if (applePayDomainNames) {
                const applePayDomainNamesValue = this.fb.array(this.initApplePayDomains(applePayDomainNames)) as any;
                if (applePayDomainNamesValue) {
                    this.tidForm.setControl(TidFormField_RC.RC_APPLE_PAY_DOMAIN_NAMES, applePayDomainNamesValue);
                    this.updateAllControlValidators();
                }
            }
        }
    }

    ngOnChanges(changes: SimpleChanges) {

        if (this.formInitialized) {
            if (changes.dynamicGooglePayMerchantId && changes.dynamicGooglePayMerchantId.currentValue) {
                this.tidForm.get(TidFormField_RC.RC_GOOGLE_PAY_MERCHANT_ID).setValue(this.dynamicGooglePayMerchantId);
                this.updateAllControlValidators();
                return;
            }
            if (changes.dynamicApplePayMerchantId && changes.dynamicApplePayMerchantId.currentValue) {
                this.tidForm.get(TidFormField_RC.RC_APPLE_PAY_MERCHANT_ID).setValue(this.dynamicApplePayMerchantId);
                this.updateAllControlValidators();
                this.scrollApplePayIntoView();
                this.cd.detectChanges();
                return;
            }
            if (changes.dynamicApplePayConfig && changes.dynamicApplePayConfig.currentValue) {
                this.updateApplePayConfig();
                return;
            }
        }

        if (changes.isCreate && changes.isCreate.firstChange) {
            this.organizationId = this.route.snapshot.params.organizationId;
            this.submitButtonText = (this.isCreate ? "Submit" : "Update");
            this.showDatawireId = this.isCreate;
        }

        if (changes.tid && this.tid) {
            this.initialiseForm();
        }

        if (!this.initCloverDevices && this.tid && (this.mids?.length > 0)) {
            setTimeout(() => this.getCloverDevicesForMid(), 0); // removes 'ExpressionChangedAfterChecked' error
            this.initCloverDevices = true;
        }

        // Workaround needed for form using ValidatorsVituCustom:
        // ValidatorsVituCustom need to be run by forcing validation if anything they depend on changes,
        // for example as a result of the allowed values being retrieved asynchronously from server (& arriving late).
        // (TODO : Consolidate use of Angular Forms in shareable form base class which implements our common form
        // behaviour like this as default for all of our forms (instead of having to apply it in multiple places))
        this.validateFormControls(this.tidForm);
    }

    get pageTitle(): string {
        const editOrView = this.editAvailable ? "Edit" : "View";
        return (this.isCreate ? "New" : editOrView) + " TID";
    }

    get editAvailable(): boolean {
        return !this.tidDeleted;
    }

    get tidDeleted(): boolean {
        return (this.tid?.deletedUtc != null);
    }

    onClickToggleShowDatawireId() {
        this.showDatawireId = !this.showDatawireId;
    }

    onClickReassignDevice() {
        if (this.isCreate) {
            return;
        }

        this.reassignDevice.emit({
            organizationId: +this.organizationId,
            merchantProcessorId: this.merchantProcessorId,
            merchantTerminalId: this.tid.id
        });
    }

    onClickPairDevice() {
        if (this.isCreate) {
            return;
        }

        this.pairDevice.emit({
            organizationId: +this.organizationId,
            merchantProcessorId: this.merchantProcessorId,
            merchantTerminalId: this.tid.id
        });
    }

    onClickDelete() {
        this.deleteTid.emit({
            id: this.tid.id,
            organizationId: this.organizationId
        });
    }

    onSubmit() {

        const gateway = this.getFieldValue(TidFormField_COMMON.COMMON_GATEWAY);
        let mai;
        let dba;
        let tid;

        let config: MerchantTerminalConfigBaseDto;

        let digitalWalletConfig: DigitalWalletConfigRequest = null;

        switch (gateway) {
            case GatewayEnum.CloverEcomm: {

                tid = undefined;    // Never send this for Clover ECOM => It will be auto-generated on server.
                mai = this.getFieldValue(TidFormField_CLOVER_ECOMM.CLOVER_ECOMM_MAI);

                const termsAndConditionsUrl = this.getFieldValue(TidFormField_CLOVER_ECOMM.CLOVER_ECOMM_TERMS_AND_CONDITIONS_URL);
                const serviceContactNumber = this.getFieldValue(TidFormField_CLOVER_ECOMM.CLOVER_ECOMM_SERVICE_CONTACT_NUMBER);

                config = {
                    $type: GatewayEnum.CloverEcomm,
                    termsAndConditionsUrl,
                    serviceContactNumber
                } as CloverEcommConfigDto;

                break;
            }
            case GatewayEnum.CloverPos: {

                tid = this.cloverPosTid;
                mai = this.getFieldValue(TidFormField_CLOVER_POS.CLOVER_POS_MAI);

                const deviceLocation = this.getFieldValue(TidFormField_CLOVER_POS.CLOVER_POS_DEVICE_LOCATION);
                const deviceName = this.getFieldValue(TidFormField_CLOVER_POS.CLOVER_POS_DEVICE_NAME);
                const deviceSerial = this.getFieldValue(TidFormField_CLOVER_POS.CLOVER_POS_DEVICE_SERIAL);
                const deviceManufacturer = this.getFieldValue(TidFormField_CLOVER_POS.CLOVER_POS_DEVICE_MANUFACTURER);
                const deviceModel = this.getFieldValue(TidFormField_CLOVER_POS.CLOVER_POS_DEVICE_MODEL);
                const status = this.getFieldValue(TidFormField_CLOVER_POS.CLOVER_POS_STATUS);
                const deviceActivationCode = this.getFieldValue(TidFormField_CLOVER_POS.CLOVER_POS_DEVICE_ACTIVATION_CODE);

                config = {
                    $type: GatewayEnum.CloverPos,
                    deviceLocation,
                    deviceName,
                    deviceSerial,
                    deviceManufacturer,
                    deviceModel,
                    status,
                    deviceActivationCode
                } as CloverPosConfigDto;

                break;
            }
            case GatewayEnum.RC: {

                tid = this.getFieldValue(TidFormField_RC.RC_TID);
                mai = this.getFieldValue(TidFormField_RC.RC_MAI);

                const googlePayMerchantId = this.getFieldValue(TidFormField_RC.RC_GOOGLE_PAY_MERCHANT_ID);
                if (googlePayMerchantId?.length) {
                    digitalWalletConfig = digitalWalletConfig || {};
                    digitalWalletConfig.googlePayConfig = {
                        identifier: googlePayMerchantId
                    };
                }
                const applePayMerchantId = this.getFieldValue(TidFormField_RC.RC_APPLE_PAY_MERCHANT_ID);
                if (applePayMerchantId?.length) {
                    digitalWalletConfig = digitalWalletConfig || {};

                    const applePayMerchantName = this.getFieldValue(TidFormField_RC.RC_APPLE_PAY_MERCHANT_NAME);
                    const applePayMerchantUrl = this.getFieldValue(TidFormField_RC.RC_APPLE_PAY_MERCHANT_URL);

                    let applePayDomainNames;
                    let applePayDomainControls = (this.tidForm.get(TidFormField_RC.RC_APPLE_PAY_DOMAIN_NAMES) as FormArray).controls;
                    if (applePayDomainControls) {
                        applePayDomainControls = applePayDomainControls.filter(applePayDomainControl =>
                                                    !((applePayDomainControl as FormGroup)?.get("updateShouldDelete")?.value));
                        applePayDomainNames = applePayDomainControls.map(
                            (control) => (control as FormGroup).get("name").value
                        );
                    }

                    digitalWalletConfig.applePayConfig = {
                        identifier: applePayMerchantId,
                        merchantName: applePayMerchantName,
                        merchantUrl: applePayMerchantUrl,
                        domainNames: applePayDomainNames
                    };
                }

                const clientTimeoutSeconds = this.getFieldValue(TidFormField_RC.RC_CLIENT_TIMEOUT_SECONDS);
                const termsAndConditionsUrl = this.getFieldValue(TidFormField_RC.RC_TERMS_AND_CONDITIONS_URL);
                const serviceContactNumber = this.getFieldValue(TidFormField_RC.RC_SERVICE_CONTACT_NUMBER);
                const groupId = this.getFieldValue(TidFormField_RC.RC_GROUP_ID);
                const taTokenType = this.getFieldValue(TidFormField_RC.RC_TA_TOKEN_TYPE);

                let datawireId = null;
                const regenerateDatawireId = this.getFieldValue(TidFormField_RC.RC_REGENERATE_DATAWIRE_ID);
                if (!regenerateDatawireId) {
                    datawireId = this.getFieldValue(TidFormField_RC.RC_DATAWIRE_ID);
                }

                config = {
                    $type: GatewayEnum.RC,
                    clientTimeoutSeconds,
                    datawireId,
                    termsAndConditionsUrl,
                    serviceContactNumber,
                    groupId,
                    taTokenType
                } as RcConfigDto;
                if (!this.isCreate) {
                    (config as RcConfigDto).project = this.getFieldValue(TidFormField_RC.RC_PROJECT);
                }

                break;
            }
            case GatewayEnum.PayPal: {
                config = {
                    $type: GatewayEnum.PayPal
                };
                tid = undefined;    // Never send this for Clover ECOM => It will be auto-generated on server.
                break;
            }
        }

        if (this.isCreate) {

            const createMerchantTerminalDto: CreateMerchantTerminalDto = {
                gateway,
                config,
                mai,
                merchantProcessorId: this.merchantProcessorId,
                tid
            };

            this.createTid.emit({
                organizationId: this.organizationId,
                dto: createMerchantTerminalDto
            });

        }
        else {

            const updateMerchantTerminalDto: UpdateMerchantTerminalDto = {
                gateway,
                config,
                mai,
                digitalWalletConfig
            };

            this.updateTid.emit({
                id: this.tid.id,
                organizationId: this.organizationId,
                dto: updateMerchantTerminalDto
            });

        }

    }

    onRegenerateDatawireIdToggled(checked: boolean, dataWireIdInput: any) {
        if (checked) {
            this.storedDataWireIdInputValue = dataWireIdInput.value;
            dataWireIdInput.value = "";
            this.storedShowDatawireId = this.showDatawireId;
        }
        else {
            dataWireIdInput.value = this.storedDataWireIdInputValue;
            this.showDatawireId = this.storedShowDatawireId;
        }
    }

    onEnableGooglePayToggled(checked: boolean) {
        if (checked) {
            this.getGooglePayMerchantId.emit({
                id: this.tid.id,
                organizationId: this.organizationId
            });
        }
        else {
            this.tidForm.get(TidFormField_RC.RC_GOOGLE_PAY_MERCHANT_ID).reset();
            this.tidForm.get(TidFormField_RC.RC_GOOGLE_PAY_MERCHANT_ID).updateValueAndValidity();
        }
    }

    onEnableApplePayToggled(checked: boolean) {
        if (checked) {
            this.getApplePayMerchantId.emit({
                id: this.tid.id,
                organizationId: this.organizationId
            });
        }
        else {
            this.tidForm.get(TidFormField_RC.RC_APPLE_PAY_MERCHANT_ID).reset();
            this.tidForm.get(TidFormField_RC.RC_APPLE_PAY_MERCHANT_NAME).reset();
            this.tidForm.get(TidFormField_RC.RC_APPLE_PAY_MERCHANT_URL).reset();
            const applePayDomainNamesValue = this.fb.array(this.initApplePayDomains()) as any;
            this.tidForm.setControl(TidFormField_RC.RC_APPLE_PAY_DOMAIN_NAMES, applePayDomainNamesValue);
            this.updateAllControlValidators();
        }
        this.cd.detectChanges();
    }

    onCancel(): void {
        this.cancel.emit();
    }

    onMidChanged() {
        if (this.gateway &&
            this.gatewaysSupportedByMid.findIndex(gateway => (gateway === this.gateway)) === -1) {
                this.tidForm.get(TidFormField_COMMON.COMMON_GATEWAY).reset();
                this.toast.open(`Please select a Gateway which supports the selected MID's processor.`, VituToastTone.Negative);
        }
        if ((this.merchantProcessorId >= 0) && (this.gateway === GatewayEnum.CloverPos)) {
            this.getCloverDevicesForMid();
        }
        this.updateAllControlValidators();
    }

    getCloverDevicesForMid() {
        const organizationId = +this.organizationId;
        const merchantProcessorId = this.merchantProcessorId;
        if ((this.merchantProcessorId >= 0) && (this.gateway === GatewayEnum.CloverPos)) {
            this.getCloverDevices.emit({organizationId, merchantProcessorId});
        }
    }

    onGatewayChanged() {
        if ((this.merchantProcessorId >= 0) &&
            (this.midsSupportedByGateway.findIndex(mid => (mid.id === this.merchantProcessorId)) === -1)) {
                this.tidForm.get(TidFormField_COMMON.COMMON_MID).reset();
                this.toast.open(`Please select a MID with processor which supports the selected Gateway.`, VituToastTone.Negative);
        }
        this.getCloverDevicesForMid();
        this.updateAllControlValidators();
    }

    updateAllControlValidators() {
        this.tidFormFields.forEach(
            tidFormField => {
                const field = this.tidForm.get(tidFormField);
                const validators = this.getControlProps(tidFormField).validators;
                field.setValidators(validators);
                field.updateValueAndValidity();
                // Becaues 'enable()' and 'disable()' cascade into children
                // we don't want to do it for the domain names form array
                // as we're managing that ourselves, so avoid that by skipping
                // the parent which doesn't need any validation.
                if (tidFormField !== TidFormField_RC.RC_APPLE_PAY_DOMAIN_NAMES) {
                    if (this.isFieldDisabled(tidFormField)) {
                        field.disable();
                    }
                    else {
                        field.enable();
                    }
                }
            }
        );
    }

    isFieldDisabled(controlName: string): boolean {
        if (!this.editAvailable) {
            return true;
        }
        const formFieldInteraction = this.getControlProps(controlName).interaction;
        return ((formFieldInteraction === FormFieldInteraction.HIDDEN) || (formFieldInteraction === FormFieldInteraction.VIEW));
    }

    isApplePayDomainDisabled(index: number): boolean {
        if (this.getFieldValue(TidFormField_RC.RC_ENABLE_APPLE_PAY)) {
            return false;
        }
        return (index < this.applePayInitialDomainsCount);
    }

    get cloverPosStatuses() {
        return this.statuses.filter(status => status !== PosTerminalStatusEnum.Reassigned);
    }

    private midValidForGateway(c: UntypedFormControl) {
        if ((this.merchantProcessorProcessor) && (this.gateway)) {
            if (this.merchantProcessorProcessor === ProcessorEnum.Fiserv) {
                if (this.gateway === GatewayEnum.PayPal) {
                    return { midInvalidForGateway: { valid: false } };
                }
            }
            else if (this.merchantProcessorProcessor === ProcessorEnum.PayPal) {
                if (this.gateway !== GatewayEnum.PayPal) {
                    return { midInvalidForGateway: { valid: false } };
                }
            }
        }
        return null;
    };

    get midsSupportedByGateway() {
        if (!this.mids.length || !this.gateway) {
            return this.mids;
        }
        return this.mids.filter(mid =>
             ((this.gateway === GatewayEnum.PayPal) && (mid.processor === ProcessorEnum.PayPal)) ||
             ((this.gateway === GatewayEnum.CloverEcomm) && (mid.processor === ProcessorEnum.Fiserv)) ||
             ((this.gateway === GatewayEnum.CloverPos) && (mid.processor === ProcessorEnum.Fiserv)) ||
             ((this.gateway === GatewayEnum.RC) && (mid.processor === ProcessorEnum.Fiserv))
        );
    }

    get gatewaysSupportedByMid() {
        if (!this.gateways.length || !this.merchantProcessorProcessor) {
            return this.gateways;
        }
        return this.gateways.filter(gateway =>
            ((this.merchantProcessorProcessor === ProcessorEnum.Fiserv) && (gateway === GatewayEnum.CloverEcomm)) ||
            ((this.merchantProcessorProcessor === ProcessorEnum.Fiserv) && (gateway === GatewayEnum.CloverPos)) ||
            ((this.merchantProcessorProcessor === ProcessorEnum.Fiserv) && (gateway === GatewayEnum.RC)) ||
            ((this.merchantProcessorProcessor === ProcessorEnum.PayPal) && (gateway === GatewayEnum.PayPal))
        );
    }

    private getControlProps(controlName: string) {

        const props = {
            interaction: FormFieldInteraction.VIEW,
            validators: [Validators.required]
        };

        switch (controlName) {
            case TidFormField_COMMON.COMMON_MID: {
                props.interaction = (this.isCreate ? FormFieldInteraction.EDIT : FormFieldInteraction.VIEW);
                props.validators =
                    [
                        Validators.required,
                        ValidatorsVituCustom.selectSingleIntegrity(() => this.mids?.map(mid => mid.mid))/*,
                        this.midValidForGateway.bind(this)*/
                    ];
                break;
            }
            case TidFormField_COMMON.COMMON_GATEWAY: {
                props.interaction = (this.isCreate ? FormFieldInteraction.EDIT : FormFieldInteraction.VIEW);
                props.validators =
                    [
                        Validators.required,
                        ValidatorsVituCustom.selectSingleIntegrity(() => this.gateways)/*,
                        this.midValidForGateway.bind(this)*/
                    ];
                break;
            }

            case TidFormField_CLOVER_ECOMM.CLOVER_ECOMM_TID: {
                props.interaction = FormFieldInteraction.VIEW;
                break;
            }
            case TidFormField_CLOVER_ECOMM.CLOVER_ECOMM_MAI: {
                props.interaction = (this.isCreate ? FormFieldInteraction.EDIT : FormFieldInteraction.VIEW);
                break;
            }
            case TidFormField_CLOVER_ECOMM.CLOVER_ECOMM_TERMS_AND_CONDITIONS_URL: {
                if (this.merchantProcessorIsServiceFee) {
                    props.validators = [];
                }
                else {
                    props.interaction = FormFieldInteraction.EDIT;
                    props.validators.push(ValidatorsVituCustom.validHttpHttps);
                }
                break;
            }
            case TidFormField_CLOVER_ECOMM.CLOVER_ECOMM_SERVICE_CONTACT_NUMBER: {
                if (this.merchantProcessorIsServiceFee) {
                    props.validators = [];
                }
                else {
                    props.interaction = FormFieldInteraction.EDIT;
                    props.validators.push(Validators.pattern(TelephoneRegex));
                }
                break;
            }
            case TidFormField_CLOVER_POS.CLOVER_POS_MAI: {
                props.interaction = (this.isCreate ? FormFieldInteraction.EDIT : FormFieldInteraction.VIEW);
                break;
            }
            case TidFormField_CLOVER_POS.CLOVER_POS_DEVICE_SERIAL: {
                if (this.isCreate) {
                    props.interaction = FormFieldInteraction.EDIT;
                    props.validators.push(Validators.pattern(/^[0-9a-zA-Z]{14}$/));
                }
                else {
                    props.interaction = FormFieldInteraction.VIEW;
                }
                break;
            }
            case TidFormField_CLOVER_POS.CLOVER_POS_DEVICE_MANUFACTURER: {
                props.interaction = this.isCreate ? FormFieldInteraction.EDIT : FormFieldInteraction.VIEW;
                props.validators =
                    [Validators.required];
                break;
            }
            case TidFormField_CLOVER_POS.CLOVER_POS_DEVICE_MODEL: {
                props.interaction = this.isCreate ? FormFieldInteraction.EDIT : FormFieldInteraction.VIEW;
                props.validators =
                    [Validators.required];
                break;
            }
            case TidFormField_CLOVER_POS.CLOVER_POS_DEVICE_NAME: {
                props.interaction = FormFieldInteraction.EDIT;
                break;
            }
            case TidFormField_CLOVER_POS.CLOVER_POS_DEVICE_LOCATION: {
                props.interaction = FormFieldInteraction.EDIT;
                break;
            }
            case TidFormField_CLOVER_POS.CLOVER_POS_STATUS: {
                if (this.isCreate) {
                    props.interaction = FormFieldInteraction.VIEW;
                    props.validators = [];
                }
                else {
                    props.interaction = FormFieldInteraction.EDIT;
                    props.validators =
                        [Validators.required, ValidatorsVituCustom.selectSingleIntegrity(() => this.statuses)];
                }
                break;
            }
            case TidFormField_CLOVER_POS.CLOVER_POS_DEVICE_ACTIVATION_CODE: {
                props.interaction = FormFieldInteraction.EDIT;
                props.validators = [Validators.pattern(/^(\d{0,8})$/)];
                break;
            }

            case TidFormField_RC.RC_TID: {
                if (this.isCreate) {
                    props.interaction = FormFieldInteraction.EDIT;
                    props.validators.push(Validators.pattern(/^[0-9a-zA-Z]{1,8}$/));
                }
                else {
                    props.interaction = FormFieldInteraction.VIEW;
                }
                break;
            }
            case TidFormField_RC.RC_MAI: {
                props.interaction = (this.isCreate ? FormFieldInteraction.EDIT : FormFieldInteraction.VIEW);
                break;
            }
            case TidFormField_RC.RC_DATAWIRE_ID: {
                if (!this.getFieldValue(TidFormField_RC.RC_REGENERATE_DATAWIRE_ID)) {
                    props.interaction = FormFieldInteraction.EDIT;
                }
                break;
            }
            case TidFormField_RC.RC_REGENERATE_DATAWIRE_ID: {
                props.interaction = FormFieldInteraction.EDIT;
                props.validators = [];
                break;
            }
            case TidFormField_RC.RC_TERMS_AND_CONDITIONS_URL: {
                props.interaction = FormFieldInteraction.EDIT;
                props.validators.push(ValidatorsVituCustom.validHttpHttps);
                break;
            }
            case TidFormField_RC.RC_SERVICE_CONTACT_NUMBER: {
                props.interaction = FormFieldInteraction.EDIT;
                props.validators.push(Validators.pattern(TelephoneRegex));
                break;
            }
            case TidFormField_RC.RC_CLIENT_TIMEOUT_SECONDS: {
                props.interaction = FormFieldInteraction.EDIT;
                props.validators.push(Validators.min(0));
                break;
            }
            case TidFormField_RC.RC_GROUP_ID: {
                props.interaction = FormFieldInteraction.EDIT;
                break;
            }
            case TidFormField_RC.RC_PROJECT: {
                props.validators = [];
                break;
            }
            case TidFormField_RC.RC_TA_TOKEN_TYPE: {
                props.interaction = FormFieldInteraction.EDIT;
                break;
            }

            case TidFormField_PayPal.PAYPAL_TID: {
                props.interaction = FormFieldInteraction.VIEW;
                break;
            }

            case TidFormField_RC.RC_ENABLE_GOOGLE_PAY: {
                props.interaction = FormFieldInteraction.EDIT;
                props.validators = [];
                break;
            }
            case TidFormField_RC.RC_GOOGLE_PAY_MERCHANT_ID: {
                if (this.getFieldValue(TidFormField_RC.RC_ENABLE_GOOGLE_PAY)) {
                    props.interaction = FormFieldInteraction.EDIT;
                }
                props.validators = [];
                break;
            }

            case TidFormField_RC.RC_ENABLE_APPLE_PAY: {
                props.interaction = FormFieldInteraction.EDIT;
                props.validators = [];
                break;
            }
            case TidFormField_RC.RC_APPLE_PAY_MERCHANT_ID: {
                if (this.getFieldValue(TidFormField_RC.RC_ENABLE_APPLE_PAY)) {
                    props.interaction = FormFieldInteraction.EDIT;
                }
                props.validators = [];
                break;
            }
            case TidFormField_RC.RC_APPLE_PAY_MERCHANT_NAME: {
                if (this.getFieldValue(TidFormField_RC.RC_ENABLE_APPLE_PAY)) {
                    props.interaction = FormFieldInteraction.EDIT;
                }
                break;
            }
            case TidFormField_RC.RC_APPLE_PAY_MERCHANT_URL: {
                if (this.getFieldValue(TidFormField_RC.RC_ENABLE_APPLE_PAY)) {
                    props.interaction = FormFieldInteraction.EDIT;
                }
                props.validators = [ValidatorsVituCustom.validHttpHttps];
                break;
            }
            case TidFormField_RC.RC_APPLE_PAY_DOMAIN_NAMES: {
                props.validators = [];
                break;
            }

        }

        const activeFormFields = this.getActiveFormFieldNames();
        if (activeFormFields.find(activeFormField => (activeFormField === controlName)) === undefined) {
            props.interaction = FormFieldInteraction.HIDDEN;
        }

        return props;
    }

    getActiveFormFieldNames(): Array<string> {
        let formFields: Array<string> = Object.values(TidFormField_COMMON);

        if (this.gateway === GatewayEnum.CloverEcomm) {
            formFields = formFields.concat(Object.values(TidFormField_CLOVER_ECOMM));
        }
        else if (this.gateway === GatewayEnum.CloverPos) {
            formFields = formFields.concat(Object.values(TidFormField_CLOVER_POS));
        }
        else if (this.gateway === GatewayEnum.RC) {
            formFields = formFields.concat(Object.values(TidFormField_RC));
        }
        else if (this.gateway === GatewayEnum.PayPal) {
            formFields = formFields.concat(Object.values(TidFormField_PayPal));
        }

        return formFields;
    }

    private getFieldValue(fieldName: string): any {
        return this.tidForm?.get(fieldName).value;
    }

    private getMerchantProcessorIdForMid(midVal: string): number {
        let id = -1;
        const filtered = this.mids.filter(mid => (mid.mid === midVal));
        if (filtered?.length) {
            id = filtered[0].id;
        }
        return id;
    }

    private getMerchantProcessorIsServiceFeeForMid(midVal: string): boolean {
        let retVal = false;
        const filtered = this.mids.filter(mid => (mid.mid === midVal));
        if (filtered?.length) {
            retVal = filtered[0].isServiceFee;
        }
        return retVal;
    }

    private getMerchantProcessorProcessorForMid(midVal: string): ProcessorEnum {
        let processor: ProcessorEnum;
        const filtered = this.mids.filter(mid => (mid.mid === midVal));
        if (filtered?.length) {
            processor = filtered[0].processor;
        }
        return processor;
    }

    private initialiseForm(): void {
        this.initialFormConfig = {
            COMMON_MID: this.tid.mid,
            COMMON_GATEWAY: this.tid.gateway,

            CLOVER_ECOMM_TID: undefined,
            CLOVER_ECOMM_MAI: undefined,
            CLOVER_ECOMM_TERMS_AND_CONDITIONS_URL: undefined,
            CLOVER_ECOMM_SERVICE_CONTACT_NUMBER: undefined,

            CLOVER_POS_MAI: undefined,
            CLOVER_POS_DEVICE_SERIAL: undefined,
            CLOVER_POS_DEVICE_MANUFACTURER: undefined,
            CLOVER_POS_DEVICE_MODEL: undefined,
            CLOVER_POS_DEVICE_NAME: undefined,
            CLOVER_POS_DEVICE_LOCATION: undefined,
            CLOVER_POS_STATUS: undefined,
            CLOVER_POS_DEVICE_ACTIVATION_CODE: undefined,

            RC_TID: undefined,
            RC_MAI: undefined,
            RC_DATAWIRE_ID: null,
            RC_REGENERATE_DATAWIRE_ID: undefined,
            RC_TERMS_AND_CONDITIONS_URL: undefined,
            RC_SERVICE_CONTACT_NUMBER: undefined,
            RC_CLIENT_TIMEOUT_SECONDS: undefined,
            RC_GROUP_ID: undefined,
            RC_PROJECT: undefined,
            RC_TA_TOKEN_TYPE: undefined,
            RC_ENABLE_GOOGLE_PAY: undefined,
            RC_GOOGLE_PAY_MERCHANT_ID: undefined,
            RC_ENABLE_APPLE_PAY: undefined,
            RC_APPLE_PAY_MERCHANT_ID: undefined,
            RC_APPLE_PAY_MERCHANT_NAME: undefined,
            RC_APPLE_PAY_MERCHANT_URL: undefined,
            RC_APPLE_PAY_DOMAIN_NAMES: undefined,

            PAYPAL_TID: undefined
        };

        let applePayDomainNamesValue = null;

        switch (this.initialFormConfig.COMMON_GATEWAY) {
            case GatewayEnum.CloverEcomm: {
                this.initialFormConfig.CLOVER_ECOMM_TID = this.tid.tid;
                this.initialFormConfig.CLOVER_ECOMM_MAI = this.tid.mai;
                const cloverEcommConfig = this.tid.config as CloverEcommConfigDto;
                this.initialFormConfig.CLOVER_ECOMM_TERMS_AND_CONDITIONS_URL = cloverEcommConfig?.termsAndConditionsUrl;
                this.initialFormConfig.CLOVER_ECOMM_SERVICE_CONTACT_NUMBER = cloverEcommConfig?.serviceContactNumber;
                break;
            }
            case GatewayEnum.CloverPos: {
                const cloverPosConfig = this.tid.config as CloverPosConfigDto;
                this.initialFormConfig.CLOVER_POS_DEVICE_SERIAL = cloverPosConfig?.deviceSerial;
                this.initialFormConfig.CLOVER_POS_DEVICE_MANUFACTURER = cloverPosConfig?.deviceManufacturer;
                this.initialFormConfig.CLOVER_POS_DEVICE_MODEL = cloverPosConfig?.deviceModel;
                this.cloverPosTid = this.tid.tid;
                this.initialFormConfig.CLOVER_POS_DEVICE_NAME = cloverPosConfig?.deviceName;
                this.initialFormConfig.CLOVER_POS_DEVICE_LOCATION = cloverPosConfig?.deviceLocation;
                this.initialFormConfig.CLOVER_POS_STATUS = cloverPosConfig?.status;
                this.initialFormConfig.CLOVER_POS_MAI = this.tid.mai;
                this.initialFormConfig.CLOVER_POS_DEVICE_ACTIVATION_CODE = cloverPosConfig?.deviceActivationCode;
                break;
            }
            case GatewayEnum.RC: {
                this.initialFormConfig.RC_TID = this.tid.tid;
                this.initialFormConfig.RC_MAI = this.tid.mai;

                const rcConfig = this.tid.config as RcConfigDto;
                this.initialFormConfig.RC_DATAWIRE_ID = rcConfig?.datawireId;
                this.initialFormConfig.RC_REGENERATE_DATAWIRE_ID = false;
                this.initialFormConfig.RC_TERMS_AND_CONDITIONS_URL = rcConfig?.termsAndConditionsUrl;
                this.initialFormConfig.RC_SERVICE_CONTACT_NUMBER = rcConfig?.serviceContactNumber;
                const clientTimeoutSeconds =
                    (typeof rcConfig?.clientTimeoutSeconds === "number") ? `${rcConfig?.clientTimeoutSeconds}` : null;
                this.initialFormConfig.RC_CLIENT_TIMEOUT_SECONDS = clientTimeoutSeconds;
                this.initialFormConfig.RC_GROUP_ID = rcConfig?.groupId;
                this.initialFormConfig.RC_PROJECT = rcConfig?.project;
                this.initialFormConfig.RC_TA_TOKEN_TYPE = rcConfig?.taTokenType;

                this.initialFormConfig.RC_ENABLE_GOOGLE_PAY = false;
                this.initialFormConfig.RC_GOOGLE_PAY_MERCHANT_ID = this.tid.digitalWalletConfig?.googlePayConfig?.identifier;
                this.formInitializedWithGoogleMerchantId = !!(this.initialFormConfig.RC_GOOGLE_PAY_MERCHANT_ID?.length);

                if (!!(this.tid.digitalWalletConfig?.digitalWalletConfigErrors?.length)) {
                    switch (this.tid.digitalWalletConfig.digitalWalletConfigErrors[0]) {
                        case DigitalWalletConfigError.NoAppleMerchantIdentifierCertificateConfigured: {
                            this.configErrorNoAppleMerchantIdCert = "You must first add an Apple Pay Merchant Identity certificate";
                            break;
                        }
                    }
                }

                this.initialFormConfig.RC_ENABLE_APPLE_PAY = false;
                this.initialFormConfig.RC_APPLE_PAY_MERCHANT_ID = this.tid.digitalWalletConfig?.applePayConfig?.identifier;
                this.formInitializedWithAppleMerchantId = !!(this.initialFormConfig.RC_APPLE_PAY_MERCHANT_ID?.length);
                this.applePayRegistered = this.tid.digitalWalletConfig?.applePayConfig?.registered;

                this.initialFormConfig.RC_APPLE_PAY_MERCHANT_NAME = this.tid.digitalWalletConfig?.applePayConfig?.merchantName;
                this.initialFormConfig.RC_APPLE_PAY_MERCHANT_URL = this.tid.digitalWalletConfig?.applePayConfig?.merchantUrl;
                const applePayDomainNames = this.tid.digitalWalletConfig?.applePayConfig?.domainNames as Array<AppleMerchantDomainName>;
                applePayDomainNamesValue = this.fb.array(this.initApplePayDomains(applePayDomainNames)) as any;

                break;
            }
            case GatewayEnum.PayPal: {
                this.initialFormConfig.PAYPAL_TID = this.tid.tid;
                break;
            }
        }

        if (!this.initialFormConfig.CLOVER_ECOMM_TID) {
            // Safe to use the CLOVER_ECOMM_TID field to display a message
            // in the case that it has no value as it is ALWAYS READONLY (i.e. not validated) and never sent to the server
            // (The TID value is only ever generated on server for this case.)
            this.initialFormConfig.CLOVER_ECOMM_TID = "TID AUTO-GENERATED";
        }

        if (!this.initialFormConfig.PAYPAL_TID) {
            // Safe to use the PAYPAL_TID field to display a message
            // in the case that it has no value as it is ALWAYS READONLY (i.e. not validated) and never sent to the server
            // (The TID value is only ever generated on server for this case.)
            this.initialFormConfig.PAYPAL_TID = "TID AUTO-GENERATED";
        }

        this.tidForm.patchValue(this.initialFormConfig);

        if (applePayDomainNamesValue) {
            this.tidForm.setControl(TidFormField_RC.RC_APPLE_PAY_DOMAIN_NAMES, applePayDomainNamesValue);
        }

        this.updateAllControlValidators();
        if (!this.isCreate) {
            this.tidForm.markAllAsTouched();
        }

        if (!this.editAvailable) {
            this.tidForm?.disable();
        }

        this.formInitialized = true;
    }

    private validateFormControls(formGroup: UntypedFormGroup): void {
        Object.keys(formGroup?.controls).forEach(field => {
            formGroup?.get(field)?.updateValueAndValidity();
        });
    }

}
